export default __webpack_public_path__ + "static/new-hero-section-image-mobile-db4bd364d78133d0bb2b3ebb5c3280ff.jpg";